( function () {
	'use strict';

	var button = document.querySelector( '[data-header-navigation-toggle]' );
	var navigation = document.getElementById( 'folis-primary-navigation' );
	var desktop = window.matchMedia( '(min-width: 768px)' );

	if ( ! button || ! navigation ) {
		return;
	}

	var openIcon = button.querySelector( '[data-menu-icon-open]' );
	var closeIcon = button.querySelector( '[data-menu-icon-close]' );

	function setOpen( isOpen ) {
		button.setAttribute( 'aria-expanded', String( isOpen ) );
		button.setAttribute( 'aria-label', isOpen ? 'Fechar menu principal' : 'Abrir menu principal' );
		navigation.classList.toggle( 'folis-navigation-open', isOpen && ! desktop.matches );
		openIcon.hidden = isOpen;
		closeIcon.hidden = ! isOpen;
	}

	button.hidden = false;
	setOpen( false );

	button.addEventListener( 'click', function () {
		setOpen( 'true' !== button.getAttribute( 'aria-expanded' ) );
	} );

	document.addEventListener( 'keydown', function ( event ) {
		if ( 'Escape' === event.key && 'true' === button.getAttribute( 'aria-expanded' ) ) {
			setOpen( false );
			button.focus();
		}
	} );

	desktop.addEventListener( 'change', function () {
		setOpen( false );
	} );
}() );
